module.exports = __webpack_public_path__ + "img/scene-changing-room-2.179f344a.jpg";